import React, { useEffect, useState } from "react";
import { Instagram, Facebook, Music2 } from "lucide-react";
import { PinterestIcon, ThreadsIcon } from "@/components/icons/Social";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  ["instagram", "Instagram", Instagram, "@thehappybulldogco or full URL"],
  ["facebook", "Facebook", Facebook, "page name or full URL"],
  ["pinterest", "Pinterest", PinterestIcon, "username or full URL"],
  ["threads", "Threads", ThreadsIcon, "@handle or full URL"],
  ["tiktok", "TikTok", Music2, "@handle or full URL"],
];

export default function SocialLinksCard() {
  const [s, setS] = useState({ instagram: "", facebook: "", pinterest: "", threads: "", tiktok: "" });
  useEffect(() => { api.get("/settings/social").then(({ data }) => setS(data)).catch(() => {}); }, []);

  const save = async () => {
    try { const { data } = await api.put("/admin/social", s); setS(data); toast.success("Social links saved — the Follow buttons are live 📣"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="social-links-card">
      <h3 className="font-display font-bold text-[#19324A] mb-1">Social media links</h3>
      <p className="text-xs text-[#19324A]/50 mb-4">Powers the "Follow the Mischief" buttons on the homepage and the footer icons. Leave blank to hide a network.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, label, Icon, ph]) => (
          <div key={k}><label className="block text-xs font-semibold text-[#19324A]/60 mb-1 inline-flex items-center gap-1"><Icon className="w-3.5 h-3.5" /> {label}</label>
            <input value={s[k] || ""} onChange={(e) => setS((v) => ({ ...v, [k]: e.target.value }))} placeholder={ph} className="w-full rounded-xl border-2 border-[#19324A]/10 px-3 py-2 text-sm outline-none focus:border-[#FFD93D]" data-testid={`social-${k}`} /></div>
        ))}
      </div>
      <button onClick={save} className="btn-pink !py-2 mt-3" data-testid="social-save">Save links</button>
    </div>
  );
}
